import { Autocomplete, Box, Stack } from '@mui/material'
import React, { useEffect, useState } from 'react'

import { FontStyle, QuestionData, defaultBottomPadding, defaultInnerStyle, defaultContainerStyle } from '../../constants';
import CheckButton from '../CheckButton';
import HeartButton from '../HeartButton'
import TempDisplay from '../TempDisplay';
import { CustomPaper, StyledTextField } from '../AutocompleteUtils';
import { useSelector } from 'react-redux';


const styles = {
  container: {
    ...defaultContainerStyle
  },
  inner: {
    ...defaultInnerStyle,
  },
  body: {
    ...FontStyle.body,
    fontSize: '1rem',
    textAlign: 'center',
    lineHeight: '1.4',
    maxWidth: '500px',
  },
  search: {
    width: '100%',
    maxWidth: '500px',
    backgroundColor: 'rgb(255, 255, 255)',
    borderRadius: '4px',
    border: '1px solid rgb(204, 204, 204)',
  },
}
const numNeeded = 1;
const numMax = 600;
const numTitles = 2;

const Q9_NegativeIndustries = ({ selected, setSelected, setQuestionsDone, questionNum, options, nextQuestion }) => {
  const serverRefreshes = useSelector(state => state.survey.serverRefreshes);
  const [defaultValues, setDefaultValues] = useState([]);
  useEffect(() => {
    if (selected[questionNum].includes(0)) {
      setQuestionsDone((prev) => ({ ...prev, [questionNum]: true }))
    } else if (selected[questionNum].includes(1) && selected[questionNum].length > 1) {
      setQuestionsDone((prev) => ({ ...prev, [questionNum]: true }))
    } else {
      setQuestionsDone((prev) => ({ ...prev, [questionNum]: false }))
    }
  }, [selected])
  // sync values from server
  useEffect(() => {
    if (serverRefreshes === 0) return;
    let newDefaultValues = [];
    selected[questionNum].map((idx) => {
      if (idx <= 1) return;
      newDefaultValues.push(options[idx]);
    })
    setDefaultValues(newDefaultValues);
  }, [serverRefreshes])
  return (
    <Stack direction='column' sx={styles.container} alignItems='center' spacing={4}>
      {/* <TempDisplay selected={selected} options={options} questionNum={questionNum} /> */}
      <Stack direction='column' sx={styles.inner} alignItems='center' justifyContent='center' spacing={1}>
        {options.slice(0, numTitles).map((option, i) => {
          return (
            <CheckButton key={i} text={option} selected={selected[questionNum].includes(i)} setSelected={() => {
              if (selected[questionNum].includes(i)) {
                setSelected(s => { return { ...s, [questionNum]: [] } })
              } else {
                setSelected(s => { return { ...s, [questionNum]: [i] } })
                if (i === 0) {
                  setTimeout(nextQuestion, 200);
                }
              }
            }}
              // disabled={selected[questionNum].length >= numMax && !selected[questionNum].includes(i)}
              noCheck
            />
          )
        })}
      </Stack>
      {selected[questionNum].includes(1) && <Stack direction='column' sx={styles.inner} alignItems='center' justifyContent='center' spacing={1}>
        <Box sx={{ ...styles.body, }}>Which industries would you like to exclude?</Box>
        <Autocomplete
          multiple
          options={options.slice(numTitles)}
          getOptionLabel={(option) => option}
          // defaultValue={defaultValues}
          value={defaultValues}
          onChange={(event, newValue) => {
            setDefaultValues(newValue);
            setSelected(s => { return { ...s, [questionNum]: [1, ...(newValue.map((v) => options.indexOf(v)))] } })
          }}
          sx={{
            width: '100%',
            '& .MuiFormControl-root': {
              border: 'none',
            }
          }}
          PaperComponent={CustomPaper}
          renderOption={(props, option, { selected }) => {
            return (
              <li {...props} style={{ textAlign: 'center', width: '100%' }}>
                <Box sx={{ margin: 'auto' }}>{option}</Box>
              </li>
            )
          }}
          renderInput={(params) => (
            <StyledTextField
              {...params}
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
              }}
              sx={styles.search}
              variant="standard"
              placeholder="Enter Industry here..."
            />
          )}
        />
      </Stack>}
    </Stack>
  )
}

export default Q9_NegativeIndustries